module.exports = __webpack_public_path__ + "static/media/grintech2(1).9a4983dd.png";